<template>
  <div class="labels-container" :class="{ 'single-line': singleLine }">
    <label v-if="!hideLabel">{{ IDPrefix }} ID</label>

    <div class="id-copy-field">
      <v-tooltip location="top" content-class="id-tooltip-small">
        <template #activator="{ props: tooltipProps }">
          <span
            v-bind="tooltipProps"
            :id="`${type}-id-${parseId(id)}-val`"
          >{{ parseId(id) }}</span>
        </template>
        <span style="font-size: 0.7rem; line-height: 1; display: block;">ID: {{ id }}</span>
      </v-tooltip>
      <SVGIcon
        v-tooltip="`Copy ${IDPrefix} ID to clipboard`"
        class="icon copy"
        :iconName="'copy'"
        :width="'16px'"
        :height="'16px'"
        @click.stop="copyToClipboard(parseId(id))"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref, toRefs,
} from 'vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { copyToClipboard as safeCopy } from '@/utils/clipboard';

const props = defineProps({
  id: {
    type: Number,
    default: 0,
  },
  type: {
    type: String,
    default: '',
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  singleLine: {
    type: Boolean,
    default: false,
  },
});

const IDPrefix = ref(null);

const {
  id,
  type,
  singleLine,
} = toRefs(props);

function parseId() {
  if (id.value && type.value) {
    let prefix = '';
    switch (type.value) {
    case 'task':
      prefix = 'bt';
      IDPrefix.value = "Task";
      break;
    case 'dataset':
      prefix = 'ds';
      IDPrefix.value = "Dataset";
      break;
    case 'annotation set':
      prefix = 'as';
      IDPrefix.value = "Annotation Set";
      break;
    case 'annotation':
      prefix = 'a';
      IDPrefix.value = "Annotation";
      break;
    case 'image':
      prefix = 'i';
      IDPrefix.value = "Image";
      break;
    case 'trainer':
      prefix = 't';
      IDPrefix.value = "Session";
      break;
    case 'validator':
      prefix = 'v';
      IDPrefix.value = "Session";
      break;
    case 'validation':
      prefix = 'v';
      IDPrefix.value = "Session";
      break;
    case 'project':
      prefix = 'p';
      IDPrefix.value = "Project";
      break;
    case 'experiment':
      prefix = 'exp';
      IDPrefix.value = "Experiment";
      break;
    case 'auto annotation':
      prefix = 'inf';
      IDPrefix.value = "Session";
      break;
    case 'sample':
      prefix = 's';
      IDPrefix.value = "Sample";
      break;
    default:
      prefix = '';
    }
    let result = '';
    if (prefix !== '') {
      result = `${prefix}-${Number(id.value).toString(16)}`;
    } else {
      result = Number(id.value).toString(16);
    }

    return result;
  }
  return '';
}

function copyToClipboard(text) {
  safeCopy(text);
}

</script>

<style lang="scss" scoped>
.labels-container {
  display: flex;
  flex-direction: column;
  label {
    font-size: 0.8rem;
    font-weight: 550;

    &.hide {
      visibility: hidden;
    }
  }

  .id-copy-field {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--body-text-color);
    gap: 8px;

    span {
      font-size: 0.85rem;
      min-width: 44px;
    }
  }

  .icon {
    margin: 0 5px 0 0;
    cursor: pointer;
    &.copy{
      color: #999;
      &:hover {
        color: #666;
      }
    }
  }

  :deep(.id-tooltip-small) {
    padding: 1px 3px !important;
    line-height: 1 !important;
    min-height: auto !important;
    background-color: #fff !important;
    color: #0066cc !important;
  }

  &.single-line {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-top: 6px;
    margin-bottom: 4px;

    label {
      white-space: nowrap;
      flex: 0 0 auto;
    }

    .id-copy-field {
      flex: 1;
    }
  }
}
</style>
